//fix menu overflow under the responsive table
// hide menu on click... (This is a must because when we open a menu )
import {element_exists} from "../../functions";
import {dropdownFix} from "../../jquery-functions-library";

export var fnDashDropdownFix = function () {

    if(!element_exists('.employee.dashboard')) return false;

    /*Clear everytime script loads. Garbage collection*/
    $('.dashboard-dropdown-container').html('');


    $(document).off('click.hideTableDropdown').on({
        'click.hideTableDropdown': hideDropdowns
    });

    function hideDropdowns() {
        //hide all our dropdowns
        $('.dropdown-menu[data-parent]').hide();

    }

    $(document).off('click', '.table-responsive [data-toggle="dropdown"]').on('click', '.table-responsive [data-toggle="dropdown"]', function () {
        // if the button is inside a modal
        dropdownFix(this)
    });
};